import React from 'react';
import { Line, Bar } from 'react-chartjs-2';
// import { Chart as ChartJS } from "chart.js/auto";
//import "chartjs-plugin-streaming";

const CommonChart = (props) => {
	if (props.chartData && Object.keys(props.chartData).length === 0) {
		return null;
	}

	if (props.type === 'bar') {
		return (
			<div style={{}} >
				<Bar data={props.chartData} options={props.options} />
			</div>
		);
	}

	return (
		<div style={{}} >
			<Line data={props.chartData} options={props.options} />
		</div>
	);
};

export default CommonChart;